import { z } from 'zod';
import { baseTaskSchema } from '../schema.base.js';

const freeTextTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("FreeText")
}).transform(it => ({
  ...it,
  content: [{
    id: "input",
    nodeType: "freetext-input"
  }]
}));

export { freeTextTaskSchema };
//# sourceMappingURL=_schema.js.map
